export default __webpack_public_path__ + "static/media/841.89efcfd2.gif";